import { render, staticRenderFns } from "./Expandables.vue?vue&type=template&id=244391e0"
import script from "./Expandables.vue?vue&type=script&lang=js"
export * from "./Expandables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports